import type { OpeningView } from '@kaiizen/kai-floor-plan-editor-core';
import { useEffect, useRef } from 'react';

/**
 * The view "Edit room" in the floor plan view hands over for a room (3D at the
 * floor plan's camera angle when it shows 3D), kept for that room only until
 * its editor has opened, which reads it once.
 */
export const useRoomOpening = (selectedGroupId: string | undefined) => {
  const openingRef = useRef<{ groupId: string; view: OpeningView } | null>(null);
  useEffect(() => {
    if (openingRef.current?.groupId === selectedGroupId) openingRef.current = null;
  }, [selectedGroupId]);
  return {
    holdOpening: (groupId: string, view: OpeningView) => {
      openingRef.current = { groupId, view };
    },
    openingFor: (groupId: string): OpeningView | undefined => openingRef.current?.groupId === groupId ? openingRef.current.view : undefined,
  };
};
